module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.data).length > 0 && ((_vm.isCrudOpers && _vm.canShowCrudButton) || _vm.isOtherOpers) && _vm.$store.state.windowWidth <= 767) ? _c('div', {
    staticClass: "w5-opers-button-for-mobile"
  }, [('create' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('create')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  })], 1) : _vm._e(), _vm._v(" "), ('update' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-green",
    attrs: {
      "icon": "pencil-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ('clone' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('clone')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "clone"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(oper, key) {
    return _c('div', {
      key: 'other-opers-' + key,
      staticClass: "w5-opers-button-curd-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.clickOper(key)
        }
      }
    }, [(_vm.isOperButtonVisible(key)) ? [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, _vm._l((_vm.classOper(key)), function(cls, idx) {
      return _c('font-awesome-icon', {
        key: 'icon-' + cls,
        class: _vm.classOperClasses(key, idx),
        attrs: {
          "icon": cls
        }
      })
    }), 1)] : _vm._e()], 2)
  }), _vm._v(" "), ('delete' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  })], 1) : _vm._e()], 2) : (Object.keys(_vm.data).length > 0 && ((_vm.isCrudOpers && _vm.canShowCrudButton) || _vm.isOtherOpers) && _vm.$store.state.windowWidth > 767) ? _c('div', {
    staticClass: "btn-group w5-opers-button",
    class: {
      'w5-opers-button-opened': _vm.show
    },
    attrs: {
      "data-index": _vm.index
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "dropdown-toggle"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "bars"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dropdown-menu",
    style: (_vm.cssUl),
    attrs: {
      "role": "menu"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.isCrudOpers && _vm.canShowCrudButton) ? [('create' in _vm.data) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('create')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['create']['title'] ? _vm.data['create']['title'] : this.crud + '/create_title')) + "\n\t\t\t\t")], 1)]) : _vm._e(), _vm._v(" "), ('update' in _vm.data) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticClass: "color-green",
    attrs: {
      "icon": "pencil-alt"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['update']['title'] ? _vm.data['update']['title'] : 'main/redact')) + "\n\t\t\t\t")], 1)]) : _vm._e(), _vm._v(" "), ('clone' in _vm.data) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('clone')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "clone"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['clone']['title'] ? _vm.data['clone']['title'] : 'main/clone')) + "\n\t\t\t\t")], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (('create' in _vm.data || 'update' in _vm.data || 'clone' in _vm.data) && _vm.isOtherOpers) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(oper, key) {
    return _c('li', {
      key: 'other-opers-' + key,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.clickOper(key)
        }
      }
    }, [(_vm.isOperButtonVisible(key)) ? [_c('font-awesome-layers', {
      staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
    }, [_vm._l((_vm.classOper(key)), function(cls, idx) {
      return _c('font-awesome-icon', {
        key: 'icon-' + cls,
        class: _vm.classOperClasses(key, idx),
        attrs: {
          "icon": cls
        }
      })
    }), _vm._v(" "), (key === 'ipptrpool') ? [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(oper['title'] ? oper['title'] : '')) + "\n\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")(oper['title'] ? oper['title'] : ''))) + "\n\t\t\t\t\t")]], 2)] : _vm._e()], 2)
  }), _vm._v(" "), (_vm.isCrudOpers && _vm.canShowCrudButton && 'delete' in _vm.data) ? [(('create' in _vm.data || 'update' in _vm.data || 'clone' in _vm.data) || _vm.isOtherOpers) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-other-btn"
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.data['delete']['title'] ? _vm.data['delete']['title'] : 'main/delete')) + "\n\t\t\t\t")], 1)])] : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64422d84"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/btndropdown.vue
// module id = 505
// module chunks = 0